module.exports = __webpack_public_path__ + "static/bg-bottom-781ad41c128e8e9db593f28d43996b9f.svg";